var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button' ].concat( _vm.cssClasses),attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }